import { withInstall } from '@pit-element-plus/utils'
import Drawer from './src/drawer.vue'

import type { SFCWithInstall } from '@pit-element-plus/utils'

export const ElDrawer: SFCWithInstall<typeof Drawer> = withInstall(Drawer)
export default ElDrawer

export * from './src/drawer'
